<template>
  <el-dialog
    title="游戏数据"
    :visible.sync="visible"
    top="2vh"
    width="1216px"
    center
    :before-close="() => $emit('reject')"
  >
    <SwitchAccount v-model="innerVisible" @sureAccount="changeAccounts" />
    <ShareView
      ref="shareView"
      :userDetailInfo="userDetailInfo"
      :userList="userList"
      :nikkiList="shareNikkiList"
      :entryFilter="entryFilter"
    />
    <div v-if="userState !== -1" class="wechat-notice-tip" @click="handleWechat">
      <div v-if="userState === 1">
        <b>微信登录并关注微信服务号，</b>即可接收微信服务通知，不再错过收菜和每日任务！更有专属游戏标签在评论区展示哦~
      </div>
      <div v-if="userState === 2"><b>关注微信服务号，</b>即可接收微信通知，不再错过收菜和每日任务！</div>
      <span class="button">{{ userState === 1 ? "立即登录" : "立即关注" }}</span>
    </div>
    <div class="black-box">
      <div class="box-header">
        <img :src="userDetailInfo.icon" alt="" class="avatar" @click="$emit('setting')" />
        <div class="user-info">
          <div class="user-name">{{ userDetailInfo.name }}</div>
          <div class="user-level">Lv.{{ userDetailInfo.basic_info.player_level }}</div>
        </div>
        <div class="game-data">
          <div class="game-data-num">{{ userDetailInfo.basic_info.avatar_frame }}</div>
          <div class="game-data-text">头像框</div>
        </div>
        <div class="game-data">
          <div class="game-data-num">{{ userDetailInfo.basic_info.own_nikke_cnt }}</div>
          <div class="game-data-text">妮姬</div>
        </div>
        <div class="game-data">
          <div class="game-data-num">{{ userDetailInfo.battle_info.costume }}</div>
          <div class="game-data-text">时装</div>
        </div>
        <div class="game-data">
          <div class="game-data-num">{{ userDetailInfo.battle_info.tower_floor }}</div>
          <div class="game-data-text">塔</div>
        </div>
        <div class="game-data">
          <div class="game-data-num">{{ userDetailInfo.battle_info.normal_progress || 0 }}</div>
          <div class="game-data-text">普通-战役</div>
        </div>
        <div class="game-data">
          <div class="game-data-num">{{ userDetailInfo.battle_info.hard_progress || 0 }}</div>
          <div class="game-data-text">困难-战役</div>
        </div>
        <div v-if="isMine" class="btn">
          <div class="btn-item">
            <div class="item-icon" @click="switchAccount">
              <img src="@/assets/black_imgs/switch_icon.png" alt="" />
            </div>

            <div class="item-text">切换</div>
          </div>
          <div class="btn-item">
            <div class="item-icon" @click="handleSetting">
              <img src="@/assets/black_imgs/setting.png" alt="" />
            </div>

            <div class="item-text">设置</div>
          </div>
          <div class="btn-item">
            <div class="item-icon" @click="refresh">
              <img src="@/assets/black_imgs/refresh_icon.png" alt="" class="reference" />
            </div>

            <div class="item-text reference">刷新</div>
          </div>
          <div class="btn-item">
            <div class="item-icon" @click="handleShare">
              <img src="@/assets/black_imgs/share_icon.png" alt="" />
            </div>

            <div class="item-text">分享</div>
          </div>
        </div>
      </div>
      <div class="box-content">
        <div class="box-content-l">
          <div class="l-container">
            <DailyTask :basicInfo="userDetailInfo.basic_info" />
            <OutPost :outPost="userDetailInfo.battle_info.outpost_detail" />
          </div>
        </div>
        <div class="box-content-r">
          <div class="r-container">
            <Nikki :nikkiList="nikkiList" :entryFilter="entryFilter" @asyncShareInfo="asyncShareInfo" />
          </div>
        </div>
      </div>
      <div class="box-bottom">
        <RealTimeInfo :basicInfo="userDetailInfo.basic_info" />
      </div>
    </div>
    <ServiceCode v-model="serviceCodeVisible" />
  </el-dialog>
</template>
<script>
// components
import { openSetting } from "@/views/wiki/components/blackBox";
import DailyTask from "./components/DailyTask.vue";
import OutPost from "./components/OutPost.vue";
import Nikki from "./components/Nikki.vue";
import RealTimeInfo from "./components/RealTimeInfo.vue";
import SwitchAccount from "./components/SwitchAccount.vue";
import ServiceCode from "./components/ServiceCode.vue";
import ShareView from "./shareView.vue";
import eventBus from "@/plugins/eventBus";

// apis
import { apiQueryList, apiGetUserNikki, apiGetUserInfo, apiAddUsername } from "@/api/blackBoxApi";
import { apiEntryFilterGetEntryFilter } from "@/api/entryFilterApi";

export default {
  components: {
    DailyTask,
    OutPost,
    Nikki,
    RealTimeInfo,
    SwitchAccount,
    ShareView,
    ServiceCode
  },
  props: {
    /** 小黑盒账号id */
    id: { type: Number, default: 0 },
    /** 小黑盒账号所属的wiki账号的id */
    uid: { type: Number, default: 0 }
  },
  data() {
    return {
      name: "",
      innerVisible: false,
      serviceCodeVisible: false,
      visible: false,
      entryFilter: [
        { children: [] },
        { children: [] },
        { children: [] },
        { children: [] },
        { children: [] },
        { children: [] }
      ],
      userDetailInfo: {
        basic_info: {
          avatar_frame: 0,
          player_level: 0,
          player_activity: 0,
          gold_mileage_ticket: 0, // 资源1-3
          silver_mileage_ticket: 0, // 资源1-4
          material_detail: {
            gem: 0, // 资源1-1
            credit: 0, // 资源1-2
            battle_data_set: 0, // 2-1
            core_dust: 0, // 2-2
            recruit_voucher: 0, // 2-3
            advanced_recruit_voucher: 0 // 2-3
          }
        },
        battle_info: {
          costume: 0,
          tower_floor: 0,
          normal_progress: 0,
          hard_progress: 0,
          outpost_detail: {
            abnormal_level: 0,
            attacker_level: 0,
            defender_level: 0,
            elysion_level: 0,
            missills_level: 0,
            pilgrim_level: 0,
            recyle_level: 0,
            supporter_level: 0,
            sychro_level: 0,
            tetra_level: 0
          }
        }
      },
      nikkiList: [],
      shareInfoList: [],
      shareNikkiList: [],
      userList: []
    };
  },
  computed: {
    /**
     * 1 未登录 && 已绑定账号
     * 2 已登录 && 未关注服务号
     */
    userState() {
      const uid = this.$store.getters.userUid;
      const service = this.$store.getters.loginUser.is_bind_min_app;
      if (!uid) return 1;
      if (!service) return 2;
      return -1;
    },
    isMine() {
      const uid = this.uid;
      const mineid = this.$store.getters.userUid;
      return uid ? uid === mineid : true;
    }
  },
  watch: {
    userList: {
      handler: function(val) {
        if (val) {
          const blackBoxUser = JSON.parse(localStorage.getItem("blackBoxUser"));
          if (!blackBoxUser?.id) {
            this.getAllInfo(this.userList[0].id);
            localStorage.setItem("blackBoxUser", JSON.stringify(val[0]));
          } else {
            this.getAllInfo(blackBoxUser.id);
          }
          this.getEntryFilter();
        }
      }
    }
  },
  beforeMount() {
    if (this.id) {
      this.getAllInfo(this.id);
    } else {
      this.fetchUserList();
    }
    this.getEntryFilter();
  },
  mounted() {
    this.visible = true;
  },
  methods: {
    async fetchUserList() {
      const { code, data } = await apiQueryList();
      if (code === 0 && data.length) {
        this.userList = data.map(item => ({ ...item, open_id: item.open_id.split("-")[1] }));
      }
    },
    asyncShareInfo(shareInfo) {
      this.shareInfoList = shareInfo;
    },
    switchAccount() {
      this.innerVisible = true;
    },
    refresh() {
      this.$message.success("刷新成功");
      const blackBoxUser = JSON.parse(localStorage.getItem("blackBoxUser"));
      this.getAllInfo(blackBoxUser.id);
    },
    handleShare() {
      this.shareNikkiList = JSON.parse(JSON.stringify(this.shareInfoList)); // 创建新引用
      this.$nextTick(() => {
        eventBus.$emit("shareBlackBox");
      });
    },
    handleWechat() {
      if (!this.isLoginShow()) return;
      this.serviceCodeVisible = true;
    },
    handleSetting() {
      if (!this.isLoginShow()) return;
      openSetting();
    },
    async changeAccounts(openId, serverId) {
      // 1、筛选是否为以绑定账号
      const index = this.userList.findIndex(item => item.open_id === openId);
      if (index !== -1) {
        localStorage.setItem("blackBoxUser", JSON.stringify(this.userList[index]));
        try {
          // 存在，重新查询数据
          await this.getAllInfo(this.userList[index].id);
        } catch (e) {
          console.log(e);
        }
      } else {
        // 不存在，重新绑定账号
        this.bindAccount(openId, serverId);
      }
      this.innerVisible = false;
    },
    async bindAccount(openId, serverId) {
      const res = await apiAddUsername({ open_id: openId, server_id: serverId });
      if (res.code === 0) {
        // 数据绑定埋点
        if (window.staticFn) {
          window.staticFn.customEvent("nikke_data_binding_succeed");
        }
        this.$message.success("由于数据绑定可能存在短暂延迟 请您耐心等待约 3 分钟后，重新进入本页面查看最新数据");
        // 账号添加成功，重新获取账号列表
        const resp = await apiQueryList();
        this.userList = resp.data.map(item => {
          return {
            ...item,
            open_id: item.open_id.split("-")[1]
          };
        });
        const index = this.userList.findIndex(item => item.open_id === openId);
        if (index !== -1) {
          localStorage.setItem("blackBoxUser", JSON.stringify(this.userList[index]));
        }
      }
    },
    async getAllInfo(id) {
      try {
        const res = await Promise.all([
          apiGetUserInfo({ id }), // 用户基本信息
          apiGetUserNikki({ id }) // nikki数据
        ]);
        const userDetail = res[0].data.basic_info;
        const basic_info = {
          material_detail: {}
        };
        Object.keys(userDetail).forEach(key => {
          if (key !== "material_detail") {
            basic_info[key] = userDetail[key] > 0 ? userDetail[key] : 0;
          } else {
            for (const i in userDetail[key]) {
              basic_info[key][i] = userDetail[key][i] > 0 ? userDetail[key][i] : 0;
            }
          }
        });
        this.userDetailInfo = res[0].data;
        this.userDetailInfo.basic_info = basic_info;
        this.nikkiList = res[1].data;
      } catch (e) {
        console.log(e);
      }
    },
    getEntryFilter() {
      apiEntryFilterGetEntryFilter({ entry_id: 64599 }).then(res => {
        if (res.code === 0) {
          this.entryFilter = res.data.entry_filter;
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.wechat-notice-tip {
  background: #fdefda;
  border-radius: 8px;
  border: 1px solid #f2a229;
  color: #ff4500;
  display: flex;
  align-items: center;
  margin: 0 0 12px;
  padding-right: 8px;
  justify-content: space-between;
  font-size: 14px;
  div {
    padding: 6px 4px 6px 8px;
  }
  .button {
    font-size: 12px;
    text-decoration-line: underline;
    cursor: pointer;
  }
}
.black-box {
  width: 100%;
  height: 100%;

  .box-header {
    position: relative;
    width: inherit;
    height: 87px;
    background: url("~@/assets/black_imgs/bg_header.png") no-repeat;
    background-size: 100%;
    display: flex;
    align-items: center;
    column-gap: 10px;
    .avatar {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      margin: 0 10px;
    }

    .user-info {
      color: #ffffff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 8px;
      margin-right: 70px;

      .user-name {
        font-weight: 400;
        font-size: 20px;
      }

      .user-level {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 57px;
        height: 29px;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 4px;
        font-weight: 400;
        font-size: 14px;
      }
    }

    .game-data {
      width: 100px;
      height: 67px;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .game-data-num {
        font-weight: 500;
        font-size: 20px;
        color: #ffffff;
      }

      .game-data-text {
        font-weight: 400;
        font-size: 16px;
        color: rgba(255, 255, 255, 0.7);
      }
    }

    .btn {
      position: absolute;
      right: 16px;
      margin-left: 30px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 10px;
      .btn-item {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 4px;
        .item-icon {
          width: 24px;
          height: 24px;
          background: rgba(255, 255, 255, 0.15);
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          cursor: pointer;

          img {
            width: 20px;
            height: 20px;
          }

          .reference {
            width: 16px;
            height: 16px;
          }
        }

        .item-text {
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
  }

  .box-content {
    width: inherit;
    display: flex;
    margin-top: 10px;

    .box-content-l {
      width: 450px;
      border-right: 2px solid #f2f2f2;

      .l-container {
        width: 430px;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
    }

    .box-content-r {
      width: 726px;
      display: flex;
      justify-content: flex-end;

      .r-container {
        width: 706px;
      }
    }
  }

  .box-bottom {
    width: inherit;
    margin: 10px 0;
  }
}
</style>
